/**
 * A regra única da senha nova (E166.F2.T04, decisão do owner de 23/10), a mesma da api
 * (`apps/api/types/senha.py`): ao menos 8 caracteres, uma letra maiúscula e um símbolo — qualquer
 * caractere que não seja letra, número ou espaço. A tela confere antes de enviar; a api recusa com
 * `SENHA_FRACA` se algo passar. Entrar não usa a regra: a senha que já existe continua valendo.
 */
export const SENHA_MINIMA = 8;

export function senhaForte(senha: string): boolean {
  return senha.length >= SENHA_MINIMA && /\p{Lu}/u.test(senha) && /[^\p{L}\p{N}\s]/u.test(senha);
}
